// src/lib/SessionManager.js
import { LOCAL_STORAGE_HVM_USERINFO } from '@/lib/Constant';

export class SessionManager {
    static SESSION_TIMEOUT = 30 * 60 * 1000; // 30분 (밀리초)
    static SESSION_KEY = 'HVM_SESSION_TIMESTAMP';
    static SESSION_LAST_ACTIVITY = 'HVM_LAST_ACTIVITY';

    // 세션 시작
    static startSession() {
        const now = Date.now();
        localStorage.setItem(this.SESSION_KEY, now.toString());
        localStorage.setItem(this.SESSION_LAST_ACTIVITY, now.toString());
        console.log('세션 시작됨:', new Date(now));
    }

    // 세션 유효성 검사
    static isSessionValid() {
        const sessionTime = localStorage.getItem(this.SESSION_KEY);
        const userInfo = localStorage.getItem(LOCAL_STORAGE_HVM_USERINFO);
        
        if (!sessionTime || !userInfo) {
            return false;
        }

        const now = Date.now();
        const elapsed = now - parseInt(sessionTime);
        
        const isValid = elapsed < this.SESSION_TIMEOUT;
        
        if (!isValid) {
            console.log('세션 만료됨. 경과 시간:', Math.floor(elapsed / 1000 / 60), '분');
        }
        
        return isValid;
    }

    // 세션 갱신 및 연장 (사용자 활동 시)
    static renewSession() {
        if (this.isSessionValid()) {
            const now = Date.now();
            // 세션 시작 시간을 현재 시간으로 재설정 (연장 효과)
            localStorage.setItem(this.SESSION_KEY, now.toString());
            localStorage.setItem(this.SESSION_LAST_ACTIVITY, now.toString());
            console.log('세션 갱신 및 연장됨:', new Date(now));
            console.log('새로운 만료 예정 시간:', new Date(now + this.SESSION_TIMEOUT));
        }
    }

    // 세션 체크 및 갱신 (HeaderLayout에서 사용)
    static checkAndRenewIfValid() {
        const userInfo = localStorage.getItem(LOCAL_STORAGE_HVM_USERINFO);
        
        // 로그인 정보가 없으면 false 반환
        if (!userInfo) {
            return false;
        }

        // 세션이 이미 만료된 경우
        if (!this.isSessionValid()) {
            console.log('세션이 이미 만료되어 갱신할 수 없습니다.');
            this.expireSession();
            return false;
        }

        // 세션이 유효한 경우 갱신 및 연장
        this.renewSession();
        return true;
    }

    // 세션 만료 처리
    static expireSession() {
        localStorage.removeItem(this.SESSION_KEY);
        localStorage.removeItem(this.SESSION_LAST_ACTIVITY);
        localStorage.removeItem(LOCAL_STORAGE_HVM_USERINFO);
        console.log('세션 만료 처리됨');
    }

    // 세션 남은 시간 (분 단위)
    static getRemainingTime() {
        const sessionTime = localStorage.getItem(this.SESSION_KEY);
        if (!sessionTime) return 0;

        const now = Date.now();
        const elapsed = now - parseInt(sessionTime);
        const remaining = this.SESSION_TIMEOUT - elapsed;
        
        return Math.max(0, Math.floor(remaining / 1000 / 60));
    }

    // 세션 남은 시간 (시:분:초 형태)
    static getRemainingTimeFormatted() {
        const totalSeconds = this.getRemainingTimeInSeconds();
        
        if (totalSeconds <= 0) return "00:00:00";
        
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }

    // 세션 남은 시간 (초 단위)
    static getRemainingTimeInSeconds() {
        const sessionTime = localStorage.getItem(this.SESSION_KEY);
        if (!sessionTime) return 0;

        const now = Date.now();
        const elapsed = now - parseInt(sessionTime);
        const remaining = this.SESSION_TIMEOUT - elapsed;
        
        return Math.max(0, Math.floor(remaining / 1000));
    }

    // 세션 만료 예정 시간
    static getSessionExpiryTime() {
        const sessionTime = localStorage.getItem(this.SESSION_KEY);
        if (!sessionTime) return null;
        
        return new Date(parseInt(sessionTime) + this.SESSION_TIMEOUT);
    }

    // 로그아웃 처리
    static logout() {
        this.expireSession();
        // 현재 페이지가 로그인 페이지가 아니면 로그인 페이지로 리다이렉트
        // 팝업 컨텍스트 또는 POP 라우트가 필요한 경우 POP으로 리다이렉트
        const isPopupName = typeof window.name === 'string' && window.name.startsWith('hvm_login_');
        if (isPopupName || window.location.pathname.includes('HFO_LO_001_POP')) {
            try { window.location.href = '/HFO_LO_001_POP?reason=session-expired'; } catch (e) { console.warn('redirect to POP failed', e); }
        } else if (window.location.pathname !== '/HFO_LO_001') {
            window.location.href = '/HFO_LO_001?reason=session-expired';
        }
    }
}